
// Simplified static page: show only title, logo, and address

function AnniversaryDinner() {
  const tileStyle = {
    display: 'block',
    padding: '16px 20px',
    borderRadius: 12,
    background: 'linear-gradient(135deg, #ffffff 0%, #fff8e1 100%)',
    color: '#661616',
    textDecoration: 'none',
    fontWeight: 700 as const,
    boxShadow: '0 6px 16px rgba(0, 0, 0, 0.08)',
    border: '1px solid #f3e8c3'
  };
  const tilesWrapStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 16,
    marginTop: 24
  };
  return (
    <div style={{ maxWidth: 720, margin: '40px auto', textAlign: 'center', padding: '24px' }}>
      <img
        src="https://stssevastorage.blob.core.windows.net/ykwebsite/logo.png"
        alt="Yugal Kunj Logo"
        style={{ height: 96 }}
      />
      <h1 style={{ marginTop: 16 }}>Yugalkunj Donation</h1>
      <p style={{ marginTop: 8 }}>2769 Duluth Hwy, Duluth, GA 30096</p>
      <div style={tilesWrapStyle}>
        <a
          href="/rms"
          style={tileStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.12)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.08)';
          }}
        >
          Radha Madhav Society
        </a>
        <a
          href="/hyc"
          style={tileStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.12)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.08)';
          }}
        >
          Harmony Youth Center
        </a>
        <a
          href="/donationreport"
          style={tileStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.12)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.08)';
          }}
        >
          Donation Report
        </a>
      </div>
    </div>
  );
}

export default AnniversaryDinner;
